// Calls the onboard Edge Function (0.R): creates the business and makes the caller its owner.
export interface OnboardResult {
  tenant_id: string;
  slug: string;
}

export async function createWorkspace(opts: { url: string; token: string; anonKey: string; name: string; fetchImpl?: typeof fetch }): Promise<OnboardResult> {
  const f = opts.fetchImpl ?? fetch;
  let res: Response;
  try {
    res = await f(opts.url, {
      method: "POST",
      headers: { "content-type": "application/json", authorization: `Bearer ${opts.token}`, apikey: opts.anonKey },
      body: JSON.stringify({ name: opts.name }),
    });
  } catch {
    throw new Error("Can't reach the server. Check your connection and try again.");
  }
  const body = (await res.json().catch(() => ({}))) as Partial<OnboardResult> & { error?: string };
  if (res.status === 404) throw new Error("Creating a workspace isn't switched on yet. Try again later; if it keeps happening, contact Ogma's team.");
  if (!res.ok || !body.tenant_id) throw new Error(body.error ?? "The workspace couldn't be created. Try again in a moment.");
  return { tenant_id: body.tenant_id, slug: body.slug ?? "" };
}
